import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TYPOLOGIES } from "@/lib/typology";
import { subtypeBySystem, specOf } from "@/lib/iwin";

let cache = null, pending = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f(cache || []));

export function loadCustomTypologies(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!pending) pending = api.get("/typologies").then(({ data }) => { cache = data; emit(); return data; }).finally(() => { pending = null; });
  return pending;
}

export function useCustomTypologies() {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    subs.add(setList);
    loadCustomTypologies().catch(() => {});
    return () => { subs.delete(setList); };
  }, []);
  return list;
}

export const setCustomTypologies = (list) => { cache = list; emit(); };
export const typologyLabel = (value) => TYPOLOGIES.find((t) => t.value === value)?.label || cache?.find((t) => t.key === value)?.label || "As drawn";

const scale = (parts, total) => {
  const sum = parts.reduce((a, b) => a + b, 0), out = parts.map((p) => Math.max(1, Math.round((p * total) / sum)));
  out[out.length - 1] += total - out.reduce((a, b) => a + b, 0);
  return out;
};

export function applyCustomTypology(item, t) {
  const L = t.layout, iw = subtypeBySystem(t.system);
  const next = { ...item, typology: t.key, type: t.type || item.type, profile_system: t.system || item.profile_system, columns: scale(L.columns, item.width), rows: scale(L.rows, item.height),
    cells: L.cells.map((r) => [...r]), spans: (L.spans || []).map((s) => ({ ...s })), panel_glass: { ...(L.panel_glass || {}) }, corners: {} };
  if (!iw) { delete next.iwin; return next; }
  const spec = specOf(iw, next);
  if (!spec.railing) delete spec.railing;
  return { ...next, ...spec };
}

export const layoutItem = (t) => ({ id: t.key || t.label, tag: "", type: t.type, width: t.layout.ref_width || t.layout.columns.reduce((a, b) => a + b, 0),
  height: t.layout.ref_height || t.layout.rows.reduce((a, b) => a + b, 0), columns: t.layout.columns, rows: t.layout.rows,
  cells: t.layout.cells, spans: t.layout.spans || [], frame_width: 50, mullion_width: 50, sash_width: 50, frame_depth: 60, panel_glass: t.layout.panel_glass || {} });
